/**
 * 共有リンクの公開 URL を組み立てる。
 * ?d=YYYY-MM-DD は有効期限の日付を示す飾りクエリ（ルーティング・API 照合には使わない）。
 */
export function buildShareUrl(token: string, expiresAt: string): string {
  const dateParam = formatExpiryDateYmd(expiresAt)
  return `${window.location.origin}/share/${token}?d=${dateParam}`
}

function formatExpiryDateYmd(expiresAt: string): string {
  const date = new Date(expiresAt)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
